// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tags_wrapper__BgR0z"};